function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  fill: "#fff",
  stroke: "none",
  cx: 6,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.1
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  fill: "#fff",
  stroke: "none",
  cx: 26,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.2
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  fill: "#fff",
  stroke: "none",
  cx: 46,
  cy: 50,
  r: 6
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  dur: "1s",
  values: "0;1;0",
  repeatCount: "indefinite",
  begin: 0.3
}));

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "L4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 0 0",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.41ccdaafeffe5947c9cd7b447ac80699.svg";
export { ForwardRef as ReactComponent };